import React, {useState, useMemo, useEffect, useRef} from "react";
import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TableSortLabel,
    Autocomplete, Box, Typography, Collapse, Stack, IconButton, Button, List, ListItem, ButtonGroup
} from "@mui/material";

import { usePDF } from 'react-to-pdf';

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {styled} from "@mui/material/styles";
import {Link} from "react-router-dom";
import {useWebSocket} from "../net/WebSocketContext";
import BlurredComponent from "../common/BlurredComponent_all";
import BlurredComponent_all from "../common/BlurredComponent_all";
import VideoPlayer from "../common/VideoPlayer";
import AlertDialog from "../common/Dialog";
import {compressMessage} from "../utils/Compression";


const Display = () => {
    const {ws, isConnected, scoreboard,refresh, loading, progress} = useWebSocket();
    const [dance_set, setDanceSet] = useState({});
    const [dance_set_slow, setDanceSetSlow] = useState({});
    const [dance_set_arr, setDanceSetArr] = useState([]);
    const [generated, setGenerated] = useState(false);
    const [dance_complete, setDance_complete] = useState(true);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [wait, setWait] = useState(false);
    const [isDone, setIsDone] = useState(false);
    const [start, setStart] = useState(true);
    const [pair_count, setPairCount] = useState(1);
    const [filters, setFilters] = useState(()=>{
        return (
        JSON.parse(localStorage.getItem("sets_filters")) ||
        {
            event: null,
            dance: "",
            category: "",
            class: "",
            round:""
        } )
    });
    const filters_ref = useRef({});
    const size = useRef(10);

    useEffect(() => {
        getSetR()
       filters_ref.current=JSON.parse(localStorage.getItem("sets_filters")) ||
        {
            event: null,
            dance: "",
            category: "",
            class: "",
            round:""
        };

    }, []);
    useEffect(() => {
        localStorage.setItem("sets_filters", JSON.stringify(filters));
    }, [filters]);
    // useEffect(() => {
    //     getSetR()
    // }, []);

    useEffect(() => {
        getSetR()
    }, [refresh]);
    useEffect(() => { // Читаем WS
                        console.log("ON_MESSAGE Sets", scoreboard)
                            if (scoreboard?.set) {
                                setDanceSet(scoreboard);
                                setDanceSetArr(scoreboard.set)
                                setGenerated(scoreboard?.generated);
                            }
                            else{
                                setDanceSet({});
                                setDanceSetArr([])
                            }
                            if (scoreboard?.events) {
                                setEvents(scoreboard.events);
                            }
                            if (scoreboard?.users_list) {
                                setUsers(scoreboard.users_list);
                            }
                            if(scoreboard?.slow){
                                setDanceSetSlow(scoreboard?.slow);
                            }
    },[scoreboard]);

    const getSetR = () => {
            if (ws && ws.readyState === WebSocket.OPEN) {
                let body = {
                    action: "scoreboard",
                }
                setWait(true)
                ws.zsend(JSON.stringify(body));
                console.log("SEND:",body);
            } else{
                console.log("Нет готовности отправлять по ws ")
            }
    };
    const getRoundAccess = (user_id, dance_set_, round) => {
        return users.find(u => u._id === user_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.[round]
            ?.[dance_set_?.class]?.[round]
    }
    const getNextRound = (current_round) =>{
        const roundList = dance_set?.events.find(f=> f?.event?.value === dance_set?.event ).roundList?.[dance_set?.dance]?.[dance_set?.category]?.[dance_set?.class] ?? []
        return roundList[(roundList)?.indexOf(current_round)+1] ?? false
    }
    const toDance = (place,event,dance,category,dance_class,round,number,leader,follower) =>{
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_start",
                place,event,dance,category,class: dance_class,round,number,leader,follower
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body);
        } else{
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const getScore =(leader_id,dance_set_) => {
        return users.find(u=>u._id === leader_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.[dance_set_?.round]
            ?.[dance_set_?.class]
    }
    const getFinal =(leader_id,dance_set_) => {
        return users.find(u=>u._id === leader_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.['slow_final']
            ?.[dance_set_?.class]?.final
    }
    const median  = (arr) => {
        if (!Array.isArray(arr) || arr.length === 0) {
            throw new Error("Массив должен содержать хотя бы один элемент");
        }

        const sorted = arr.slice().sort((a, b) => a - b); // Копируем и сортируем массив
        const mid = Math.floor(sorted.length / 2);

        return sorted.length % 2 !== 0
            ? sorted[mid]                 // Если нечетное количество элементов
            : (sorted[mid - 1] + sorted[mid]) / 2; // Если четное - среднее двух центральных
    }
    const sum = arr => arr?.reduce((acc, num) => acc + num, 0);
    const roundTo3 = num => Math.round(num * 100) / 100; //округление до сотых
    /*
    Вычисляем баллы
    */
    const getBalls = (leader_id, dance_set_) =>{
        const scores = getScore(leader_id,dance_set_)
        //console.log(scores)
        const b = []
        //console.log(events)
        const jd  = events.find(e=>e?.event?.value === dance_set_?.event)
            ?.['JudgingList']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.[dance_set_?.class]
        jd?.map((key,index) => {
            b[index] ??= []
            b[index][0] =   ( scores?.[key]?.basic_leader * 7.5 )/5
            b[index][1] =   ( scores?.[key]?.basic_follow * 7.5 )/5
            b[index][2] =   (( scores?.[key]?.lfbdh  +
                scores?.[key]?.dance_perf  +
                scores?.[key]?.bonus1*1 ) *  15 ) / 10
            b[index][3] = (scores?.[key]?.execution  +
                scores?.[key]?.diff_var  +
                scores?.[key]?.bonus2*1)
            b[index][4] = ( (scores?.[key]?.interpret  +
                scores?.[key]?.spontan  +
                scores?.[key]?.bonus3*1 ) * 25 ) /10
        })

        // Транспонируем массив (группируем по столбцам)
        const transposed = b[0]?.map((_, i) => b?.map(row => row[i]));
        // Считаем медиану для каждого столбца
        const medians = transposed?.map(median);
        //console.log("medians",medians);

        // Вычисляем коэффициенты
        const difference = b?.map(row => row?.map((value, i) => value - medians[i]));
        //console.log("difference",difference);
        const coefficients = difference?.map(row => row?.map(c => 1 / (1 + c * c)));
        //console.log("coefficients",coefficients);
        const scaled_marks = b?.map((row, i) => row.map((value, j) => value * coefficients[i][j]));
        //console.log("scaled_marks",scaled_marks);

        const coefficients_sum = coefficients[0]?.map((_, index) => {
            return coefficients?.reduce((sum, currentArray) => sum + currentArray[index], 0);
        });

        const scaled_marks_sum = scaled_marks[0]?.map((_, index) => {
            return scaled_marks?.reduce((sum, currentArray) => sum + currentArray[index], 0);
        });

        const tmp = scaled_marks_sum?.map((value, index) => value / (coefficients_sum[index] || 0));
        //console.log("tmp",tmp);

        const result_sum = sum(tmp)
        //console.log(result_sum)

        //return b
        return roundTo3(result_sum)
    }

    // Сортировка
    const sortedData = useMemo(() => {
        return( [...dance_set_arr].sort((a, b) => {
            let valueA, valueB
            if(dance_set?.round === "fast" || dance_set?.round === "fast_final"){
                valueA = roundTo3((getBalls(a?.leader?.id, dance_set) + (getBalls(a?.leader?.id, dance_set)* 0.1))  + getBalls(a?.leader?.id, dance_set_slow))
                valueB = roundTo3((getBalls(b?.leader?.id, dance_set) + (getBalls(b?.leader?.id, dance_set)* 0.1))  + getBalls(b?.leader?.id, dance_set_slow))
            }
            else {
                valueA =  getBalls(a?.leader?.id, dance_set) ?? "";
                valueB =  getBalls(b?.leader?.id, dance_set) ?? "";
            }
            return Number(valueB) - Number(valueA);
        }))

    }, [dance_set_arr, isDone]);

    return (
        <Box margin={"10px"}  sx={{
                 margin: "auto",
                 mt: 0,
                 ml:1,
                 mr:1,
                 p: 0,
                 overflow: 'auto',
                 height: (window.innerHeight - 50) + 'px'}} >
            <BlurredComponent_all isBlurred={(!isConnected || loading)} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"} />
            <Stack direction="row" spacing={2}>
            </Stack>
            <div>
            {/* Таблица */}
            <Typography align="center" variant="subtitle1"  sx={{fontSize:"20px"}}>
                {
                    (events?.find(e=>e?.event?.value === dance_set?.event)?.event?.name ??  "Тут будет отображаться судейство, а пока ждём-с...")
                    + ' ' + ( dance_set?.dance ?? "" )
                    + ' ' + ( dance_set?.category ?? "" )
                    + ' ' + ( dance_set?.class ?? "" )
                    + ' ' + (( dance_set?.round ?? "" ) === "1" ? "финал" : ( dance_set?.round ?? "" )  ).toUpperCase()
                    + ' ' + ( dance_set?.final ?? "" ).toUpperCase()
                }
            </Typography>
            <TableContainer component={Paper} sx={{mt: 3}}>
                {
                    dance_set.category === "Strictly" ?
                    <Table style={{minWidth: "800px"}}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{fontSize:size+"px"}}>{"Место"}</TableCell>
                            <TableCell sx={{fontSize:size+"px"}}>Номер пары</TableCell>
                            <TableCell sx={{fontSize:size+"px"}}>Leader</TableCell>
                            <TableCell sx={{fontSize:size+"px"}}>Follower</TableCell>
                            <TableCell sx={{fontSize:size+"px"}}>{ "Судьи" }</TableCell>
                            <TableCell sx={{fontSize:size+"px"}}>{ "Баллы" }</TableCell>
                            {(dance_set?.round === 'fast' || dance_set?.round === 'hope') ?
                                <TableCell sx={{fontSize:size+"px"}}>{ "" }</TableCell>:""}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {( sortedData ?? []).map((set, index) => {
                            if(set?.jading_status){
                            return (
                                <TableRow key={`${index}`} style={{
                                    backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ? "#008f0029" :
                                        ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                }}
                                          hover={false}>
                                    <TableCell sx={{fontSize: size+"px"}}>{Math?.trunc((index) / pair_count) + 1}</TableCell>
                                    <TableCell sx={{fontSize: size+"px"}}>{set?.number ?? null}</TableCell>
                                    <TableCell sx={{fontSize: size+"px"}}>{set?.leader?.name ?? "_"}</TableCell>
                                    <TableCell sx={{fontSize: size+"px"}}>{set?.follower?.name ?? "_"}</TableCell>
                                    {(set?.jading_status ?
                                            <TableCell style={{}}>
                                                <div style={{display:"flex"}}>
                                                {Object.entries(set?.jading_status).map(([key, value]) => {
                                                return  !isDone ? <div style={{display:"",fontSize: "10px"}} key={`${key}`}>
                                                    {
                                                        <div style={{display:"flex"}} >
                                                            <div style={{
                                                                width: '10px',
                                                                height: '10px',
                                                                backgroundColor:  value === 0 ? "red" : (value === 1? "yellow" : "green") ,
                                                                borderRadius: '50%',
                                                                marginRight: '2px'
                                                            }}></div>
                                                        </div>

                                                    }</div> : ''})}
                                                </div>
                                            </TableCell>
                                            :<TableCell style={{padding: "4px"}}></TableCell>
                                    )}
                                    <TableCell
                                    sx={{fontSize: size+"px"}}
                                    >{ (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ?
                                        ((dance_set?.round === 'fast' || dance_set?.round === 'fast_final')  ?
                                                (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set) + (getBalls(set?.leader?.id, dance_set)* 0.1))  + getBalls(set?.leader?.id, dance_set_slow))*65)/136.5)) || '_'
                                                : getBalls(set?.leader?.id, dance_set) || '_'

                                        )
                                        :  "Выступает"}</TableCell>
                                    {(dance_set?.round === 'fast' || dance_set?.round === 'hope') ?
                                    <TableCell>
                                        { getFinal(set?.leader?.id,dance_set) ? "В финале": ''}
                                    </TableCell> :""}
                                </TableRow>)}
                            }
                        )}
                    </TableBody>
                </Table>
                    :
                        (
                            dance_set.category === "J&J" ?
                            <Table style={{minWidth: "800px"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{fontSize:size+"px"}}>Номер</TableCell>
                                <TableCell sx={{fontSize:size+"px"}}>Участник</TableCell>
                                <TableCell sx={{fontSize:size+"px"}}>Роль</TableCell>
                                <TableCell sx={{fontSize:size+"px"}}>{ "Статус судейства" }</TableCell>
                                <TableCell sx={{fontSize:size+"px"}}>{ "" }</TableCell>
                                {(dance_set?.round === 'fast' || dance_set?.round === 'hope') ?
                                    <TableCell sx={{fontSize:size+"px"}}>{ "" }</TableCell>:""}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {( sortedData ?? []).map((set, index) => {
                                    if(set?.jading_status && set?.leader?.id){
                                        return (
                                            <TableRow key={`${index}`} style={{
                                                backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ? "#008f0029" :
                                                    ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                            }}
                                                      hover={false}>
                                                <TableCell sx={{fontSize: size+"px"}}>{set?.number ?? null}</TableCell>
                                                <TableCell sx={{fontSize: size+"px"}}>{set?.leader?.name ?? "_"}</TableCell>
                                                <TableCell sx={{fontSize: size+"px"}}>Leader</TableCell>
                                                {(set?.jading_status ?
                                                        <TableCell style={{}}>
                                                            <div style={{display:"flex"}}>
                                                                {Object.entries(set?.jading_status).map(([key, value]) => {
                                                                    return  !isDone ? <div style={{display:"",fontSize: "10px"}} key={`${key}`}>
                                                                        {
                                                                            <div style={{display:"flex"}} >
                                                                                <div style={{
                                                                                    width: '10px',
                                                                                    height: '10px',
                                                                                    backgroundColor:  value === 0 ? "red" : (value === 1? "yellow" : "green") ,
                                                                                    borderRadius: '50%',
                                                                                    marginRight: '2px'
                                                                                }}></div>
                                                                            </div>

                                                                        }</div> : ''})}
                                                            </div>
                                                        </TableCell>
                                                        :<TableCell style={{padding: "4px"}}></TableCell>
                                                )}
                                                <TableCell
                                                    sx={{fontSize: size+"px"}}
                                                >{ (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ?

                                                    ( filters?.round !== '1' ?
                                                            getRoundAccess(set?.["leader"]?.id, dance_set, getNextRound(dance_set.round) ) ? "в "+
                                                                (getNextRound(dance_set.round) === "1" ? "финале" : getNextRound(dance_set.round)
                                                                ) : ""
                                                        : '')

                                                    :  "Выступает"}</TableCell>
                                            </TableRow>)}
                                }
                            )}
                            {( sortedData ?? []).map((set, index) => {
                                    if(set?.jading_status && set?.follower?.id){
                                        return (
                                            <TableRow key={`${index}`} style={{
                                                backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ? "#008f0029" :
                                                    ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                            }}
                                                      hover={false}>
                                                <TableCell sx={{fontSize: size+"px"}}>{set?.number ?? null}</TableCell>
                                                <TableCell sx={{fontSize: size+"px"}}>{set?.follower?.name ?? "_"}</TableCell>
                                                <TableCell sx={{fontSize: size+"px"}}>Follower</TableCell>
                                                {(set?.jading_status ?
                                                        <TableCell style={{}}>
                                                            <div style={{display:"flex"}}>
                                                                {Object.entries(set?.jading_status).map(([key, value]) => {
                                                                    return  !isDone ? <div style={{display:"",fontSize: "10px"}} key={`${key}`}>
                                                                        {
                                                                            <div style={{display:"flex"}} >
                                                                                <div style={{
                                                                                    width: '10px',
                                                                                    height: '10px',
                                                                                    backgroundColor:  value === 0 ? "red" : (value === 1? "yellow" : "green") ,
                                                                                    borderRadius: '50%',
                                                                                    marginRight: '2px'
                                                                                }}></div>
                                                                            </div>

                                                                        }</div> : ''})}
                                                            </div>
                                                        </TableCell>
                                                        :<TableCell style={{padding: "4px"}}></TableCell>
                                                )}
                                                <TableCell
                                                    sx={{fontSize: size+"px"}}
                                                >{ (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2)) ?
                                                    ( filters?.round !== '1' ?
                                                        getRoundAccess(set?.["follower"]?.id, dance_set, getNextRound(dance_set.round) ) ? "в "+
                                                            (getNextRound(dance_set.round) === "1" ? "финале" : getNextRound(dance_set.round)
                                                            ) : ""
                                                        : '')
                                                    :  "Выступает"}</TableCell>
                                                {(dance_set?.round === 'fast' || dance_set?.round === 'hope') ?
                                                    <TableCell>
                                                        { getFinal(set?.leader?.id,dance_set) ? "В финале": ''}
                                                    </TableCell> :""}
                                            </TableRow>)}
                                }
                            )}
                        </TableBody>
                    </Table> : ""
                        )
                }
            </TableContainer>
        </div>
        </Box>
    );
};

export default Display;
